import React from "react";

export const EdenredCallback: React.FC = React.memo(() => {
  window.opener.postMessage(window.location.search, undefined);

  window?.close();

  return null;
});
